<template>
  <div class="page-opportunity-tab-info" v-loading.fullscreen="loading" id="top">
    <div class="container is-gap-top" data-aos="fade-in" data-aos-once="true" id="top-main">
      <div class="columns is-gapless is-flex is-multiline">
        <div class="column is-12 has-text-left">

          <!-- <el-button class="inline-middle is-gap-large-top"
            v-if="isDevOrLocal"
            type="info" @click="() => {}" style="margin-left:15px;" size="mini">
            Auto Fill (Debug)
          </el-button> -->
          <div class="info-content tiptap-editor"
            v-html="dataJob && dataJob.description">
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Constants from '@/constants'
// import OpeningFormConstants from '@/pages/opportunities/formopening/formconstants'
import Util from '@/util'
// import StringUtil from '@/util/string'
// import FileUtil from '@/util/file'
// import EventBus from '@/controllers/EventBus'

// import File from '@/apis/file'
// import Upload from '@/apis/upload'

export default {
  name: 'page-opportunity-tab-info',
  props: {
    // msg: String
    dataJob: {},
  },
  components: {
    // InfoBlock,
    // Formm,
    // FormOpening,
  },
  data () {
    return {
      name: 'form-opening',
      loading: false,
      isDesktop: true,
      isDevOrLocal: (Constants.isDev || Constants.isLocalhost),
      // data
    }
  },
  computed: {
    _: function () {
      return _
    },

    Util: function () {
      return Util
    },
  },
  watch: {
  },
  created () {
  },
  async mounted () {
  },
  methods: {
  },
}
</script>

<style lang="scss" src="../../../styles/base.scss"></style>
<style lang="scss">
@import "../../../styles/app_setting.scss";
@import "../../../styles/base_tiptap.scss";

.page-opportunity-tab-info {
  .info-content {
    // background-color: lightgreen;
    padding: 12px;
  }
}

</style>
